import type { AllRouteEndpoints } from "../routeTypes";

export const appsAppIdFirebaseCredential = "/apps/:app_id/fsa_credential";

export const appsAppIdFirebaseCredentialCacheKeys: AllRouteEndpoints[] = [appsAppIdFirebaseCredential];
